import React from "react";
import {t} from '@insight/toolkit-utils';
import {Icon, Currency} from '@insight/toolkit-react';

export const ProrationTable = ({ccxProduct, currency}) => {
    const {customerLevel, levels} = ccxProduct;
    const hasMultipleLevels = levels.length > 1;

    const displayCCXLevels = () => {
        return (
            <div className="c-product-specifications__ccx__levels">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th className="c-product-specifications__ccx__levels__th--level">{t('Level')}</th>
                            <th className="c-product-specifications__ccx__levels__th--qty">{t('License qty')}</th>
                            <th colSpan={2}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {levels.map((level) => (
                            <tr key={level.code} className={Number(customerLevel) === Number(level.level) ? 'c-product-specifications__ccx__levels__current' : ''}>
                                <td>{Number(customerLevel) === Number(level.level) && <Icon icon="checkmark-circled" type="success" />}</td>
                                <td>{t('Level')} {level.level}</td>
                                <td>
                                    {`${level?.licenseRange}`}
                                </td>
                                <td className="c-product-specifications__ccx__levels__td--level-pricing">
                                    {`${t('Level')} ${level.level} ${t('pricing')}`}
                                    <Currency value={level.price} currencyCode={currency} size="small" />
                                    {t('per license')}
                                </td>
                                <td className="c-product-specifications__ccx__levels__td--proration">
                                    {<ProrationApplied proration={level.prorationApplied} />}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
    return (
        <div className="c-product-specifications__ccx o-grid__item u-1/1">
            {hasMultipleLevels && displayCCXLevels()}
        </div>
    )
}

export const CCXCurrentProduct = ({ccxProduct, currency}) => {
    const { customerLevel, levels, daysRemaining} = ccxProduct;
    const currentLevel = levels.filter(level => Number(level.level) === Number(customerLevel))[0];
    const { level, price, prorationApplied } = currentLevel;
    const has3YearsCommitment = customerLevel >= 12;
    const hasLessThanYear = daysRemaining < 365;
    const prorationMessageLowLevel = (
        <div className="c-product-specifications__ccx__verbiage">
            <Icon icon="information-circled" size={28} />
            <span>
                {t('This account is currently at level ')} {customerLevel}. {t('There are ')} {daysRemaining} {t(' days left in your subscription cycle.')}
            </span>
        </div>
    )
    const prorationMessageHighLevel = (
        <div className="c-product-specifications__ccx__verbiage">
            <Icon icon="information-circled" size={28} />
            <span>
                {t('This account is currently at level ')} {customerLevel}. {t('There are ')} {daysRemaining % 365} {t(' days remaining in the current annual subscription cycle')} {hasLessThanYear ? `${t(' and in the 3-year commitment.')}` : `${t(' and ')} ${daysRemaining} ${t(' days remaining in the 3-year commitment.')}`}
            </span>
        </div>
    )
    const prorationMessage = has3YearsCommitment ?  prorationMessageHighLevel : prorationMessageLowLevel;
    return (
        <div className="c-product-specifications__ccx">
            {prorationMessage}
            <div className="c-product-specifications__ccx__price">
                {t('Level')} {level} {t('pricing')} <Currency value={price} currencyCode={currency} size="large" /> {t('per license')}
                {<ProrationApplied proration={prorationApplied} withBG={true} />}
            </div>
        </div>
    );
}

export const ProrationApplied = ({proration, withBG = false}) => {
    if(!proration) {
        return null;
    }
    return (
        <span className={`c-product-specifications__ccx__applied ${withBG ? 'u-bg-gray' : ''}`}>
            {t('Proration applied')}
        </span>
    )
}